import {GET_CONTACTS, GET_PROJECTS, BROADCAST_NOTIFICATION, BROADCAST_NOTIFICATION_USER_LIST} from "./type";

const initalState = {
    contactList:null,
    getContact: {},
    projectsList:null,
    getProjects:{},
    notificationData: null,
    broadcastNotification: {},
    broadcastNotificationUserList: [],
};

const SendNotification = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_CONTACTS:
            return {
                ...state,
                contactList: payload,
            };
        case GET_PROJECTS:
            return {
                ...state,
                projectsList: payload,
            };
        case BROADCAST_NOTIFICATION:
            return {
                ...state,
                notificationData: payload,
            };
        case BROADCAST_NOTIFICATION_USER_LIST:
            return {
                ...state,
                broadcastNotificationUserList: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default SendNotification;
